// @flow
import { type SearchBucketDTO, SearchValueType } from "data/types";
import loc from "i18next";

// inPoint.Forms/Controls/Search/Search/SearchViewModel.cs
const GetDefaultSearchBuckets = (): Array<SearchBucketDTO> => [
    {
        visible: true,
        icon: "clock",
        name: "Geaendert_am",
        caption: loc.t("common:filter.ModifyTimeCaption"),
        valueType: SearchValueType.RelativeDate,
        selected: [],
        buckets: [
            {
                value: "Today",
                caption: loc.t("common:filter.RelativeDate.Today"),
            },
            {
                value: "Yesterday",
                caption: loc.t("common:filter.RelativeDate.Yesterday"),
            },
            {
                value: "ThisWeek",
                caption: loc.t("common:filter.RelativeDate.ThisWeek"),
            },
            {
                value: "ThisMonth",
                caption: loc.t("common:filter.RelativeDate.ThisMonth"),
            },
            {
                value: "LastMonth",
                caption: loc.t("common:filter.RelativeDate.LastMonth"),
            },
            {
                value: "ThisYear",
                caption: loc.t("common:filter.RelativeDate.ThisYear"),
            },
            {
                value: "LastYear",
                caption: loc.t("common:filter.RelativeDate.LastYear"),
            },
        ],
    },
    {
        visible: true,
        icon: "child",
        name: "Erstellt_am",
        caption: loc.t("common:filter.CreationTimeCaption"),
        valueType: SearchValueType.RelativeDate,
        selected: [],
        buckets: [
            {
                value: "Today",
                caption: loc.t("common:filter.RelativeDate.Today"),
            },
            {
                value: "Yesterday",
                caption: loc.t("common:filter.RelativeDate.Yesterday"),
            },
            {
                value: "ThisWeek",
                caption: loc.t("common:filter.RelativeDate.ThisWeek"),
            },
            {
                value: "ThisMonth",
                caption: loc.t("common:filter.RelativeDate.ThisMonth"),
            },
            {
                value: "LastMonth",
                caption: loc.t("common:filter.RelativeDate.LastMonth"),
            },
            {
                value: "ThisYear",
                caption: loc.t("common:filter.RelativeDate.ThisYear"),
            },
            {
                value: "LastYear",
                caption: loc.t("common:filter.RelativeDate.LastYear"),
            },
        ],
    },
    {
        visible: true,
        icon: "save",
        name: "Groesse",
        caption: loc.t("common:filter.FileSizeCaption"),
        valueType: SearchValueType.FileSize,
        hideName: true,
        selected: [],
        buckets: [
            { value: "Empty", caption: loc.t("common:filter.FileSize.Empty") },
            { value: "Tiny", caption: loc.t("common:filter.FileSize.Tiny") },
            { value: "Small", caption: loc.t("common:filter.FileSize.Small") },
            {
                value: "Medium",
                caption: loc.t("common:filter.FileSize.Medium"),
            },
            { value: "Large", caption: loc.t("common:filter.FileSize.Large") },
            { value: "Huge", caption: loc.t("common:filter.FileSize.Huge") },
            {
                value: "VeryHuge",
                caption: loc.t("common:filter.FileSize.VeryHuge"),
            },
        ],
    },
    // {
    //     icon: "file",
    //     name: "ItemType",
    //     caption: "Typ",
    //     valueType: SearchValueType.ItemType,
    //     hideName: true,
    //     selected: [],
    //     buckets: [
    //         { value: "Document", caption: "Dokumente" },
    //         { value: "Folder", caption: "Ordner" }
    //     ]
    // },
    // {
    //     visible: true,
    //     icon: "sort",
    //     name: SORT_BUCKET_NAME,
    //     caption: loc.t("common:filter.SortCaption"),
    //     valueType: SearchValueType.NotSet,
    //     selected: [""],
    //     buckets: [
    //         {
    //             value: "",
    //             caption: loc.t("common:filter.RelevanceCaption"),
    //         },
    //         { value: "Name", caption: loc.t("common:filter.NameCaption") },
    //         {
    //             value: "Erstellt_am",
    //             caption: loc.t("common:filter.CreationTimeCaption"),
    //         },
    //         {
    //             value: "Geaendert_am",
    //             caption: loc.t("common:filter.ModifyTimeCaption"),
    //         },
    //         // ,
    //         // {
    //         //     value: "__SORT:DESC_",
    //         //     caption: loc.t("common:filter.SortDescending")
    //         // }
    //     ],
    // },
];

export default GetDefaultSearchBuckets;
